import { SLIDER_MENUS } from 'modules/nav/constants';
import styled from 'styled-components';
import { colors, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

const StyledIndicator = styled.span`
  display: block;
  width: ${pxToRem(10)};
  height: ${pxToRem(10)};
  position: absolute;
  top: ${spacing.half};
  right: ${pxToRem(10)};
  background-color: ${colors.red50};
  border-radius: 50%;
  border: ${spacing.eighth} solid ${colors.white};
`;

export const NotificationIndicator = ({ count, navKey }: { count: number; navKey: string }) => {
  const isNotificationCenter = navKey === SLIDER_MENUS.OPEN_NOTIFICATION_CENTER;
  const hasNotifications = count > 0;

  const shouldShow = isNotificationCenter && hasNotifications;

  return <>{shouldShow && <StyledIndicator />}</>;
};
